export const ROUTER_QS_PARSE_OPTIONS = {
  allowDots: true,
} as const

export const ROUTER_QS_STRINGIFY_OPTIONS = {
  allowDots: true,
  arrayFormat: 'indices',
  encodeValuesOnly: true,
} as const

export const API_QS_STRINGIFY_OPTIONS = {
  allowDots: true,
  arrayFormat: 'indices',
  encode: false,
} as const
